import { IllinoisPurchaseCost } from '..'

export const PurchaseCost = { ...IllinoisPurchaseCost }
